<!-- App Maintain Capsule -->
<div class="d-flex flex-column align-items-center">
  <img width="80" height="80" [src]='message.imageUrl' class="gameTitleImgClass">
  <p class="mt-2">{{message.description}}</p>

</div>
<!-- * App Maintain Capsule-->